'use client'

import { useSession } from '@marketplace-web/shared/session'

import { reloadPage } from '@marketplace-web/shared/browser'

import { declineComplaintResolved } from '@marketplace-web/domain/conversation-support-data'
import { useConversationContext } from '@marketplace-web/messaging/conversation-providers-feature'
import {
  ConversationActionButton,
  ConversationActionProps,
} from '@marketplace-web/messaging/conversation-action-feature'

import useHelpCenterSessionTracking from 'hooks/useHelpCenterSessionTracking'
import { useTracking } from '@marketplace-web/observability/event-tracker-data'
import { continueConversationClicked } from '_libs/common/event-tracker/events'
import { getFeedbackType } from 'components/AutomatedResponseFeedbackModal/utils'

type Props = ConversationActionProps

const RefuseComplaintResolved = ({ title, primary, size, theme, inverse, action }: Props) => {
  const { user } = useSession()

  const { conversation } = useConversationContext()
  const conversationId = conversation?.id
  const { track } = useTracking()
  const { helpCenterSessionId } = useHelpCenterSessionTracking()

  async function continueConversation() {
    if (!user?.id || !conversationId || !helpCenterSessionId) return

    track(
      continueConversationClicked({
        helpCenterSessionId,
        threadId: conversationId.toString(),
        supportType: getFeedbackType(action),
      }),
    )

    await declineComplaintResolved(conversationId)

    reloadPage()
  }

  return (
    <ConversationActionButton
      primary={primary}
      text={title}
      size={size}
      inverse={inverse}
      theme={theme}
      onClick={continueConversation}
    />
  )
}

export default RefuseComplaintResolved
